import styled from 'styled-components';

export const Paragraph = styled.div`
  margin-left: auto;
  margin-right: auto;
  line-height: 1.45;
  max-width: none;
  font-size: 16px;

  &:first-child {
    margin-top: 0;
  }

  &:last-child {
    margin-bottom: 0;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.mediumSmall}px) {
    font-size: 18px;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.medium}px) {
    max-width: 50%;
  }
`;

export const ARTICLE_BODY_MOBILE_PADDING = 24;
export const ARTICLE_BODY_DESKTOP_PADDING = 90;
